import {
  IStorage
} from './index'
import {
  IStore,
  Theme
} from '../index'
import {
  IAccommodation,
  IContactRequestPostData,
  ICriterion,
  ICurrency,
  ICurrencyData,
  IListResponse,
  ILocation,
  IPricePayload,
  IRequestExtended,
  ISeason,
  ITaste,
  ITravelFilterDataExtended,
  IType,
  Partner,
  ITravelLimits,
  ITravelData,
  ITravel,
  IPartner,
  IContactRequest,
  IServiceType,
  IContactWay,
  IFaqItem,
  IPlatformInfo,
  IPlatformInfoData,
  ISolution,
  ITravelFilterData,
  IModal,
  IModalData,
  IServiceTypeFilterData,
  IServiceTypePriceReverse,
  IModalInitData,
  IServiceOrderData,
  IAddOrderResponseData,
  IOrder,
  IDate,
  ITravelInfoIdsExtendedData,
  IRequestServiceData,
  IRequestServicePostData,
  IContactData,
  IContact,
  IOrderData,
  ICheckout,
  ICheckoutResponse,
  IOrderHistory,
  IRequestServiceHistory,
  IPublicPlanOrderData,
  IRequestTravelHistory,
  IPlanOrderData,
  ISolutionOrderData,
  ISolutionFilterData,
  IPromoCode,
  ICertItemFilterData,
  IPromoCodeOrderData,
  IRequestPromoCodeHistory, IAppendServiceData, IRequestService, IOrderUpdateStatus, IBeautyPlaceData, INewsData, INews, IBeautyPlace
} from '../../entities'

export const makeStorage = (store: IStore): IStorage => ({
  getters: {
    getPlatformInfo(): IPlatformInfo {
      return store.getters.getPlatformInfo
    },
    getAllCurrencies(): ICurrency[] {
      return store.getters.getAllCurrencies
    },
    getCurrentCurrency(): ICurrency {
      return store.getters.getCurrentCurrency
    },
    getPriceLabel(value: number | string): string {
      return store.getters.getPriceLabel(value)
    },
    wrapPriceLabel(value: string): string {
      return store.getters.wrapPriceLabel(value)
    },
    getTravel(): ITravel | undefined {
      return store.getters.getTravel
    },
    // getModal(): IModal | undefined {
    //     return store.getters.getModal
    // },
    getOrder(): IOrder | undefined {
      return store.getters.getOrder
    },

    getLocaleDate(value: IDate, noTime?: boolean): string {
      return store.getters.getLocaleDate(value, noTime)
    }
  },

  actions: {
    updatePlatformInfo(): void {
      store.dispatch('updatePlatformInfo')
    },

    fetchServiceTypes(payload?: IServiceTypeFilterData): Promise<IServiceType[]> {
      return store.dispatch('fetchServiceTypes', payload)
    },
    getServiceTypeById(payload: number): Promise<IServiceType | undefined> {
      return store.dispatch('getServiceTypeById', payload)
    },
    fetchServiceTypePrices(payload?: IServiceTypeFilterData): Promise<IServiceTypePriceReverse[]> {
      return store.dispatch('fetchServiceTypePrices', payload)
    },
    getServiceTypePriceById(payload: number): Promise<IServiceTypePriceReverse | undefined> {
      return store.dispatch('getServiceTypePriceById', payload)
    },

    fetchSolutions(payload?: ISolutionFilterData): Promise<ISolution[]> {
      return store.dispatch('fetchSolutions', payload)
    },
    getSolutionById(payload: number): Promise<ISolution | undefined> {
      return store.dispatch('getSolutionById', payload)
    },

    setRequestServiceContact(payload: IRequestExtended<IRequestServicePostData>): Promise<IContact> {
      return store.dispatch('setRequestServiceContact', payload)
    },
    getRequestServiceHistories(payload: IRequestExtended): Promise<IRequestServiceHistory[]> {
      return store.dispatch('getRequestServiceHistories', payload)
    },

    fetchCurrencies(): void {
      store.dispatch('fetchCurrencies')
    },
    setCurrency(payload: ICurrencyData): void {
      store.dispatch('setCurrency', payload)
    },
    getPrice(payload: IPricePayload): Promise<number> {
      return store.dispatch('getPrice', payload)
    },
    setTravel(payload: ITravelData): void {
      store.dispatch('setTravel', payload)
    },
    setFilters(payload: ITravelFilterData): void {
      store.dispatch('setFilters', payload)
    },

    fetchTravels(payload?: IRequestExtended<ITravelFilterDataExtended>): Promise<IListResponse<ITravel[]>> {
      return store.dispatch('fetchTravels', payload)
    },
    getTravelById(payload: number): Promise<ITravel | undefined> {
      return store.dispatch('getTravelById', payload)
    },
    getTravelLimits(): Promise<ITravelLimits> {
      return store.dispatch('getTravelLimits')
    },

    // criteria
    fetchCriterion(payload: string): Promise<ICriterion<string>[]> {
      return store.dispatch('fetchCriterion', payload)
    },

    fetchAccommodation(): Promise<IAccommodation[]> {
      return store.dispatch('fetchAccommodation')
    },
    getAccommodationById(payload: number): Promise<IAccommodation | undefined> {
      return store.dispatch('getAccommodationById', payload)
    },

    fetchTravelType(): Promise<IType[]> {
      return store.dispatch('fetchTravelType')
    },
    getTravelTypeById(payload: number): Promise<IType | undefined> {
      return store.dispatch('getTravelTypeById', payload)
    },

    fetchTaste(): Promise<ITaste[]> {
      return store.dispatch('fetchTaste')
    },
    getTasteById(payload: number): Promise<ITaste | undefined> {
      return store.dispatch('getTasteById', payload)
    },

    fetchLocation(): Promise<ILocation[]> {
      return store.dispatch('fetchLocation')
    },
    getLocationById(payload: number): Promise<ILocation | undefined> {
      return store.dispatch('getLocationById', payload)
    },

    fetchSeason(): Promise<ISeason[]> {
      return store.dispatch('fetchSeason')
    },
    getSeasonById(payload: number): Promise<ISeason | undefined> {
      return store.dispatch('getSeasonById', payload)
    },


    fetchPartners(): Promise<Partner[]> {
      return store.dispatch('fetchPartners')
    },
    getPartnerById(payload: number): Promise<IPartner | undefined> {
      return store.dispatch('getPartnerById', payload)
    },

    fetchBeautyPlaces():  Promise<IBeautyPlaceData[]>{
      return store.dispatch('fetchBeautyPlaces')
    },
    getBeautyPlaceById(payload:number): Promise<IBeautyPlace | undefined>{
      return store.dispatch('getBeautyPlaceById', payload)
    },

    fetchNews(): Promise<INewsData[]>{
      return store.dispatch('fetchNews')
    },
    getNewsById(payload:number): Promise<INews | undefined>{
      return store.dispatch('getNewsById', payload)
    },

    fetchContactWays(): Promise<IContactWay[]> {
      return store.dispatch('fetchContactWays')
    },
    getContactWayById(payload: number): Promise<IContactWay | undefined> {
      return store.dispatch('getContactWayById', payload)
    },

    fetchFaqItems(): Promise<IFaqItem[]> {
      return store.dispatch('fetchFaqItems')
    },
    getFaqItemById(payload: number): Promise<IFaqItem | undefined> {
      return store.dispatch('getFaqItemById', payload)
    },

    addContactRequest(payload: IContactRequestPostData): Promise<IContactRequest> {
      return store.dispatch('addContactRequest', payload)
    },

    fetchPromoCodes(payload?: IRequestExtended<ICertItemFilterData>): Promise<IPromoCode[]> {
      return store.dispatch('fetchPromoCodes', payload)
    },
    getRequestPromoCodeHistories(payload: IRequestExtended): Promise<IRequestPromoCodeHistory[]> {
      return store.dispatch('getRequestPromoCodeHistories', payload)
    },
    appendService(payload: IRequestExtended<IAppendServiceData>): Promise<IRequestService> {
      return store.dispatch('appendService', payload)
    },
    cancelOrder(payload: IRequestExtended): Promise<IOrderUpdateStatus> {
      return store.dispatch('cancelOrder', payload)
    },

    // setModal(payload: IModalData): void {
    setModal(payload: IModalInitData): void {
      store.dispatch('setModal', payload)
    },
    closeModal(): void {
      store.dispatch('closeModal')
    },

    addServiceOrder(payload: IServiceOrderData): Promise<IAddOrderResponseData> {
      return store.dispatch('addServiceOrder', payload)
    },
    addPublicPlanOrder(payload: IPublicPlanOrderData): Promise<IAddOrderResponseData> {
      return store.dispatch('addPublicPlanOrder', payload)
    },
    addPlanOrder(payload: IPlanOrderData): Promise<IAddOrderResponseData> {
      return store.dispatch('addPlanOrder', payload)
    },
    addSolutionOrder(payload: ISolutionOrderData): Promise<IAddOrderResponseData> {
      return store.dispatch('addSolutionOrder', payload)
    },
    addPromoCodeOrder(payload: IPromoCodeOrderData): Promise<IAddOrderResponseData> {
      return store.dispatch('addPromoCodeOrder', payload)
    },

    getOrderByToken(payload: IRequestExtended): Promise<IOrder | undefined> {
      return store.dispatch('getOrderByToken', payload)
    },
    addConsultationInfo(payload: IRequestExtended<ITravelInfoIdsExtendedData>): Promise<void> {
      return store.dispatch('addConsultationInfo', payload)
    },
    getOrderHistories(payload: IRequestExtended): Promise<IOrderHistory[]> {
      return store.dispatch('getOrderHistories', payload)
    },
    getRequestTravelHistories(payload: IRequestExtended): Promise<IRequestTravelHistory[]> {
      return store.dispatch('getRequestTravelHistories', payload)
    },

    setOrder(payload: IOrderData): void {
      store.dispatch('setOrder', payload)
    },

    checkout(payload: ICheckout): Promise<ICheckoutResponse> {
      return store.dispatch('checkout', payload)
    },

    setLoading(payload: boolean): void {
      store.dispatch('setLoading', payload)
    },
    setTheming(payload: boolean): void {
      store.dispatch('setTheming', payload)
    },
    setTheme(payload: Theme): void {
      store.dispatch('setTheme', payload)
    },
  },

  mutations: {
    fetchCurrencies(payload: ICurrencyData[]): void {
      store.commit('fetchCurrencies', payload)
    },
    setCurrency(payload: ICurrencyData): void {
      store.commit('setCurrency', payload)
    },

    // setModal(payload?: IModalData) {
    setModal(payload?: IModalInitData): void {
      store.commit('setModal', payload);
    },
    setOrder(payload: IOrderData): void {
      store.commit('setOrder', payload)
    },

    setPlatformInfo(payload: IPlatformInfoData): void {
      store.commit('setPlatformInfo', payload)
    },
    setTravel(payload: ITravelData): void {
      store.commit('setTravel', payload)
    },
    setFilters(payload: ITravelFilterData) {
      store.commit('setFilters', payload)
    },

    setLoading(payload: boolean): void {
      store.commit('setLoading', payload)
    },
    setTheming(payload: boolean): void {
      store.commit('setTheming', payload)
    },
    setTheme(payload: Theme): void {
      store.commit('setTheme', payload)
    },
  }
})
